export interface EntityStatus {
    isFinished: boolean;
    canFinish?: boolean;
    canRemovePreviousPoint?: boolean;
}
